import styled from 'styled-components'
import NumberInputComponent from 'ui/src/components/controls/number-input'

export const Ext = styled.span`
    margin-left: 0.25em;
    opacity: 0.7;
`

export const NumberInput = styled(NumberInputComponent)`
    margin-right: 10px;
    width: 70px;

    &:last-of-type {
        margin-right: 0;
    }
`
